/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleListItem_article$ref = any;
type InfoStringListItem_item$ref = any;
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InfoStringList_viewer$ref: FragmentReference;
export type InfoStringList_viewer = {|
  +infoStrings: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: InfoStringListItem_item$ref
      |}
    |}>
  |},
  +configurableBlock: ?{|
    +id: string,
    +type: ConfigurableBlockType,
    +slug: ?string,
    +config: ?any,
    +active: ?boolean,
  |},
  +articles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: ArticleListItem_article$ref
      |}
    |}>
  |},
  +$refType: InfoStringList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InfoStringList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "blockSlug",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "infoStrings",
      "name": "infoStrings",
      "storageKey": null,
      "args": null,
      "concreteType": "InfoStringConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "InfoStringEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "InfoString",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "InfoStringListItem_item",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "configurableBlock",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "blockSlug",
          "type": "String"
        }
      ],
      "concreteType": "ConfigurableBlock",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "config",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "active",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "articles",
      "name": "articleForInfoStrings",
      "storageKey": "articleForInfoStrings(first:100)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        }
      ],
      "concreteType": "ArticleConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Article",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ArticleListItem_article",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b0e574e298b06c003d1084d7f7d04824';
module.exports = node;



// WEBPACK FOOTER //
// src/components/info-strings/__generated__/InfoStringList_viewer.graphql.js